import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { prettifyDate } from '../../../utils/string';
import './PayoutBatchListItem.scss';

export default class PayoutBatchListItem extends Component {
    static propTypes = {
        item: PropTypes.any,
        onGoToItem: PropTypes.func
    };

    renderDate(date) {
        return date ? prettifyDate(date, { returnDateOnly: true }) : 'No Date';
    }

    render() {
        const payoutBatch = this.props.item;

        return (
            <div
                className="payout-batch-list-item"
                onClick={this.props.onGoToItem}
            >
                <div className="list-item-left">
                    <span className="batch-ref">
                        {payoutBatch.batchRef}
                    </span>
                </div>
                <div className="list-item-right">
                    <span className="batch-count">
                        Payout Count: {payoutBatch.payoutCount}
                    </span>
                </div>
            </div>
        );
    }
}
